"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWithCheckboxContainer = exports.DateRowInputField = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var fi_1 = require("react-icons/fi");
var theme_1 = require("./theme");
var UIComponents_1 = require("./UIComponents");
var TextInputField_1 = require("./TextInputField");
var DateRowInputField = function (_a) {
    var label = _a.label, description = _a.description, startInputField = _a.startInputField, endInputField = _a.endInputField;
    var hasTextLabels = !!(startInputField === null || startInputField === void 0 ? void 0 : startInputField.label) && !!(endInputField === null || endInputField === void 0 ? void 0 : endInputField.label);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement(UIComponents_1.ui.Label, { label: label, description: description }),
        react_1.default.createElement(InputRow, null,
            react_1.default.createElement(exports.InputWithCheckboxContainer, null,
                react_1.default.createElement(TextInputField_1.TextInputField, __assign({}, startInputField, { label: hasTextLabels ? startInputField === null || startInputField === void 0 ? void 0 : startInputField.label : null })),
                startInputField.relatedField),
            react_1.default.createElement(IconWrapper, { hasTextLabels: hasTextLabels },
                react_1.default.createElement(ArrowRight, { color: theme_1.theme.colors.gray600, size: 24 }),
                react_1.default.createElement(ArrowDown, { color: theme_1.theme.colors.gray600, size: 24 })),
            react_1.default.createElement(exports.InputWithCheckboxContainer, null,
                react_1.default.createElement(TextInputField_1.TextInputField, __assign({}, endInputField, { label: hasTextLabels ? endInputField === null || endInputField === void 0 ? void 0 : endInputField.label : null })),
                endInputField.relatedField))));
};
exports.DateRowInputField = DateRowInputField;
var InputRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  ", ";\n  gap: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  ", ";\n  gap: ", ";\n  margin-bottom: ", ";\n"])), (0, theme_1.mq)({
    "flex-direction": ["column", "row"],
    "align-items": ["center", "flex-start"],
}), theme_1.theme.space.xsmall, theme_1.theme.space.medium);
var IconWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", ";\n"], ["\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", ";\n"])), theme_1.theme.colors.white, theme_1.theme.space.large, theme_1.theme.space.large, function (_a) {
    var hasTextLabels = _a.hasTextLabels;
    return hasTextLabels ? "margin-top: ".concat(theme_1.theme.space.medium) : "";
});
var ArrowRight = (0, styled_1.default)(fi_1.FiArrowRight)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (0, theme_1.mq)({
    display: ["none", "unset"],
}));
var ArrowDown = (0, styled_1.default)(fi_1.FiArrowDown)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (0, theme_1.mq)({
    display: ["unset", "none"],
}));
exports.InputWithCheckboxContainer = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  & > :not(:last-child) {\n    margin-bottom: ", ";\n  }\n\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  & > :not(:last-child) {\n    margin-bottom: ", ";\n  }\n\n  width: 100%;\n"])), theme_1.theme.space.xsmall);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
